
const map = {
    './analyzeDocument.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/analyzeDocument.svg'),
'./juese.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/juese.svg'),
'./kehuzu.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/kehuzu.svg'),
'./liucheng.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/liucheng.svg'),
'./moban.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/moban.svg'),
'./peixun.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/peixun.svg'),
'./shuju.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/shuju.svg'),
'./yonghu.svg': () => require('/home/vsts/work/1/s/src/layouts/rightContentRender/components/settings/svg/yonghu.svg')
};

module.exports = (id) => {
    if (map[id]) return map[id]();
    else {
        const e = new Error("Cannot find module '" + id + "'");
        e.code = 'MODULE_NOT_FOUND';
        throw e;
    }
};
